import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/nft/phone-2.webp")